// Shared date-range helpers for the quick-select buttons (main view + report).
// Each returns { start, end } as YYYY-MM-DD strings.

export function ymd(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

// Jooksev kuu: 1st of this month -> today.
export function currentMonthRange() {
  const now = new Date();
  return { start: ymd(new Date(now.getFullYear(), now.getMonth(), 1)), end: ymd(now) };
}

// Eelmine kuu: full previous month.
export function previousMonthRange() {
  const now = new Date();
  const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const end = new Date(now.getFullYear(), now.getMonth(), 0); // last day of previous month
  return { start: ymd(start), end: ymd(end) };
}

// Esimene pool kuud: most recent completed 1–15.
// On/after the 16th -> this month; before the 16th -> previous month.
export function firstHalfRange() {
  const now = new Date();
  const monthOffset = now.getDate() >= 16 ? 0 : -1;
  const y = now.getFullYear();
  const m = now.getMonth() + monthOffset;
  return { start: ymd(new Date(y, m, 1)), end: ymd(new Date(y, m, 15)) };
}

// Viimane pool kuud: most recent completed 16–end of month.
// The current month's second half isn't finished until month-end, so this is
// always the previous month's 16..last-day (handles 28/29/30/31 automatically).
export function lastHalfRange() {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  return { start: ymd(new Date(y, m - 1, 16)), end: ymd(new Date(y, m, 0)) };
}
